<template>
<div v-if="isDropdown" class="navbar-item has-dropdown has-dropdown-up is-hoverable">
  <a class="navbar-link is-arrowless">
    <img class="lang-img" :src="flag" @click="toggleMobileFlags" />
  </a>
  <div v-if="mobileFlags" class="navbar-dropdown flag-dropdown">
    <a class="navbar-item" href="#" data-lang="en" @click.prevent="onChangeLang" >
      <img  class="lang-img" src="@/assets/flag-gb@2x.png" />
    </a>
    <a class="navbar-item" href="#" data-lang="es" @click.prevent="onChangeLang" >
      <img  class="lang-img" src="@/assets/flag-ch@2x.png" />
    </a>
  </div>
</div>
<div v-else class="navbar-lan-switcher">
  <a class="navbar-item" href="#" data-lang="en" @click.prevent="onChangeLang" >
    <img class="lang-img" src="@/assets/flag-gb@2x.png" />
  </a>
  <a class="navbar-item" href="#" data-lang="es" @click.prevent="onChangeLang" >
    <img class="lang-img" src="@/assets/flag-ch@2x.png" />
  </a>
</div>
</template>
<script>
import flagGB from '@/assets/flag-gb@2x.png'
import flagCH from '@/assets/flag-ch@2x.png'

export default {
  methods: {
    toggleDropdown () {
      this.isActive = !this.isActive
    },
    closeDropdown () {
      this.isActive = false
    },
    onChangeLang (e) {
      this.mobileFlags = false
      const lang = e.currentTarget.getAttribute('data-lang')
      this.$i18n.locale = lang
      this.$localStorage.set('locale', lang)
      this.changeFlag(lang)
    },
    changeFlag (lang) {
      this.flag = this.flags[lang] || flagGB
    },
    toggleMobileFlags () {
      this.mobileFlags = !this.mobileFlags
    }
  },
  mounted () {
    const locale = this.$localStorage.get('locale')
    if (locale) {
      this.$i18n.locale = locale
      this.changeFlag(locale)
    }
  },
  props: {
    isDropdown: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: false,
      flag: flagGB,
      flags: {
        'en': flagGB,
        'zh': flagCH
      },
      mobileFlags: false
    }
  }
}
</script>
<style lang="scss" scoped>
  .navbar-link {
    padding: 0;
  }
  .navbar-dropdown {
    border-bottom-width: 0px !important;
    border-radius: 8px !important;
    box-shadow: 0 8px 8px rgba(17, 17, 17, 0.1) !important;
    border: 1px solid #ddd !important;
  }

  .flag-dropdown {
    min-width: 58px;
  }

  .navbar-lan-switcher {
    display: flex;
    flex-direction: column;

    .navbar-item {
      justify-content: flex-start;
      padding: 0;
    }
  }
  // .navbar-item {
  //   &.has-dropdown {
  //     padding-left: 0;
  //   }
  // }
  .lang-img {
    width: 24px;
  }
  .navbar-item {
    &.has-dropdown {
      padding-top: 2px !important;
    }
  }
  @media screen and (min-width: 769px) {
    .navbar-dropdown {
      .navbar-item {
        padding-right: 0rem !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/flag-items.vue